import React from 'react';

// Builds a compact page-number list like: 1 ... 4 5 6 ... 10 — the current
// page plus one neighbour on each side, with the first/last page always
// shown and gaps collapsed to an ellipsis.
const getPageNumbers = (currentPage, totalPages) => {
  const delta = 1;
  const pages = [1];

  const rangeStart = Math.max(2, currentPage - delta);
  const rangeEnd = Math.min(totalPages - 1, currentPage + delta);

  if (rangeStart > 2) pages.push('ellipsis-start');
  for (let i = rangeStart; i <= rangeEnd; i++) pages.push(i);
  if (rangeEnd < totalPages - 1) pages.push('ellipsis-end');

  if (totalPages > 1) pages.push(totalPages);
  return pages;
};

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const pages = getPageNumbers(currentPage, totalPages);

  return (
    <nav className="flex items-center justify-center flex-wrap gap-2 mt-8" aria-label="Pagination">
      <button
        type="button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1.5 rounded-md border text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100"
      >
        Previous
      </button>

      {pages.map((page, index) =>
        typeof page === 'number' ? (
          <button
            key={page}
            type="button"
            onClick={() => onPageChange(page)}
            aria-current={page === currentPage ? 'page' : undefined}
            className={`px-3 py-1.5 rounded-md border text-sm font-medium ${
              page === currentPage ? 'bg-[#2D3092] text-white border-[#2D3092]' : 'hover:bg-gray-100'
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`${page}-${index}`} className="px-2 text-gray-400">
            …
          </span>
        )
      )}

      <button
        type="button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1.5 rounded-md border text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100"
      >
        Next
      </button>
    </nav>
  );
};

export default Pagination;
